"use client";

import { MinusIcon, PlusIcon } from "./icons";

type Props = {
  quantity: number;
  onChange: (quantity: number) => void;
  label: string;
  min?: number;
  max?: number;
  disabled?: boolean;
  canIncrease?: boolean;
};

export function QuantityStepper({ quantity, onChange, label, min = 0, max = 50, disabled, canIncrease = true }: Props) {
  return (
    <div className="inline-flex h-10 items-center rounded-[4px] border border-paper/40" role="group" aria-label={`Quantity of ${label}`}>
      <button
        type="button"
        className="flex h-full w-10 items-center justify-center hover:bg-paper/10 disabled:opacity-40"
        onClick={() => onChange(quantity - 1)}
        disabled={disabled || quantity <= min}
        aria-label={quantity - 1 <= 0 ? `Remove ${label}` : `One fewer ${label}`}
      >
        <MinusIcon />
      </button>
      <span className="w-8 text-center text-[0.9375rem] tabular-nums" aria-live="polite">
        {quantity}
      </span>
      <button
        type="button"
        className="flex h-full w-10 items-center justify-center hover:bg-paper/10 disabled:opacity-40"
        onClick={() => onChange(quantity + 1)}
        disabled={disabled || !canIncrease || quantity >= max}
        aria-label={`One more ${label}`}
      >
        <PlusIcon />
      </button>
    </div>
  );
}
